var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Trend"},[_c('H5Navheader',{attrs:{"name":'流转趋势'}}),_c('div',{staticClass:"main-body"},[_c('div',{staticClass:"chart-wrap"},[_vm._m(0),_c('div',{ref:"lineChartRef1",staticStyle:{"width":"100%","height":"450px"}})])]),_c('H5Tab',{attrs:{"index":1}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("每日流转量")])])
}]

export { render, staticRenderFns }